// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1ONWO","itemTitle":"ClientEmergencyInfo_itemTitle__ogaPO","itemText":"ClientEmergencyInfo_itemText__3BBmN"};